<div class="addContainer" data-tour="evt-modal">
  <div class="modalHeader">
    <div class="editRowModal">
      <div class="modalHeader clearfix">
        <div class="modal-about">
          {{ dialogTitle }}
        </div>
      </div>
    </div>
    <button (click)="dialogRef.close()" aria-label="Close dialog" class="modal-close-button" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content>
    <form (ngSubmit)="submit()" [formGroup]="healthEventForm" class="register-form m-4">

      <!-- ========================================================= -->
      <!-- ✅ TUTOR: SELECT PACIENTE (SOLO SI APLICA) -->
      <!-- - Si no elige => se manda su propio idPaciente -->
      <!-- - Si elige => se manda el idPaciente seleccionado -->
      <!-- ========================================================= -->
      @if (showTutorSelect) {
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
            <mat-form-field appearance="outline" class="example-full-width">
              <mat-label>ASIGNAR EVENTO A (OPCIONAL)</mat-label>

              <mat-select
                [(ngModel)]="selectedPacienteId"
                (selectionChange)="onTutorPacienteChange()"
                [ngModelOptions]="{ standalone: true }"
                data-tour="evt-patient">
                <mat-option [value]="null">MI PERFIL (POR DEFECTO)</mat-option>

                @for (p of tutorPacientes; track p.idPaciente) {
                  <mat-option [value]="p.idPaciente">
                    <div class="tutor-option">
                      <div class="avatar">
                        @if (p.imagenSrc) {
                          <img [src]="p.imagenSrc" alt="IMG" />
                        } @else {
                          <span class="initials">{{ p.initials }}</span>
                        }
                      </div>
                      <div class="info">
                        <div class="name">{{ p.nombreCompleto }}</div>
                      </div>
                    </div>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>TIPO DE EVENTO</mat-label>
            <mat-select
              (selectionChange)="onEventChange($event.value)"
              formControlName="eventoDeSalud"
              required
              data-tour="evt-type">
              @for (evento of events; track evento) {
                <mat-option [value]="evento.idEvento">
                  {{ evento.nombreEvento }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <div
            *ngIf="healthEventForm.get('eventoDeSalud')?.touched && healthEventForm.get('eventoDeSalud')?.hasError('required')"
            class="custom-error-below">
            <small class="text-danger">{{ getErrorMessage() }}</small>
          </div>
        </div>
      </div>

      @if (healthEventForm.get('eventoDeSalud')?.value === 14) {

        @if (hasHiddenMeds) {
          <div class="rx-hidden-chip" [class.rx-hidden-chip--open]="showHiddenMeds">
            <div class="rx-hidden-chip__left">
              <mat-icon class="rx-hidden-chip__icon">
                {{ showHiddenMeds ? 'visibility' : 'visibility_off' }}
              </mat-icon>

              <span class="rx-hidden-chip__text">
                MEDICAMENTOS OCULTOS
              </span>
              <button
                mat-button
                type="button"
                class="rx-hidden-chip__action"
                (click)="toggleMedicamentosOcultos()">
                <mat-icon class="rx-hidden-chip__action-icon">
                  {{ showHiddenMeds ? 'visibility_off' : 'visibility' }}
                </mat-icon>
                {{ showHiddenMeds ? 'OCULTAR' : 'VER' }}
              </button>
            </div>
          </div>
        }

        <!-- ✅ Select: solo si hay medicamentos visibles (o ya se cargaron con PIN) -->
        @if (medications.length > 0) {
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
              <mat-form-field appearance="outline" class="example-full-width">
                <mat-label>MEDICAMENTO ACTIVO</mat-label>
                <mat-select formControlName="medicamentoSeleccionado">
                  @for (medicamento of medications; track medicamento) {
                    <mat-option [value]="medicamento">
                      {{ medicamento.medicamento }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        } @else {
          <!-- ✅ Empty: solo si NO hay ocultos (si hay ocultos, ya mostramos el banner y no ponemos texto extra) -->
          @if (!hasHiddenMeds) {
            <div class="rx-empty rx-empty--inline">
              <mat-icon class="rx-empty-icon">info</mat-icon>
              <span>NO HAY MEDICAMENTOS ACTIVOS REGISTRADOS.</span>
            </div>
          }
        }
      }

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="date-field example-full-width">
            <mat-label>FECHA</mat-label>

            <input
              [matDatepicker]="fechaInicial"
              [max]="maxDate"
              aria-autocomplete="none"
              autocomplete="nope"
              formControlName="fecha"
              matInput
              required
              data-tour="evt-date"
            />

            <mat-datepicker-toggle [for]="fechaInicial" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #fechaInicial></mat-datepicker>
          </mat-form-field>

          <div *ngIf="healthEventForm.get('fecha')?.touched && healthEventForm.get('fecha')?.hasError('maxDate')"
               class="custom-error-below">
            <small class="text-danger">NO SE PERMITE UNA FECHA POSTERIOR A HOY.</small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>DESCRIPCION:</mat-label>
            <textarea
              appUppercaseNoAccent
              aria-autocomplete="none"
              autocomplete="nope"
              formControlName="descripcion"
              matInput
              required
              (blur)="trimDescripcion()"
              data-tour="evt-desc-text"
            ></textarea>
          </mat-form-field>

          <div *ngIf="healthEventForm.get('descripcion')?.touched && healthEventForm.get('descripcion')?.hasError('required')"
               class="custom-error-below">
            <small class="text-danger">DESCRIPCION ES OBLIGATORIA.</small>
          </div>

          <div *ngIf="healthEventForm.get('descripcion')?.touched && healthEventForm.get('descripcion')?.hasError('requiredTrimmed')"
               class="custom-error-below">
            <small class="text-danger">DESCRIPCION ES OBLIGATORIA.</small>
          </div>

          <div *ngIf="healthEventForm.get('descripcion')?.touched && healthEventForm.get('descripcion')?.hasError('edgeSpaces')"
               class="custom-error-below">
            <small class="text-danger">NO SE PERMITEN ESPACIOS AL INICIO O AL FINAL.</small>
          </div>

          <div *ngIf="healthEventForm.get('descripcion')?.touched && healthEventForm.get('descripcion')?.hasError('pattern')"
               class="custom-error-below">
            <small class="text-danger">SOLO SE PERMITEN LETRAS, NUMEROS Y CARACTERES . , _ # / - ( ). DEBE CONTENER AL MENOS UN CARACTER ALFANUMERICO.</small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <div class="example-button-row">
            <button (click)="confirmAdd()" [disabled]="!healthEventForm.valid" [mat-dialog-close]="1" color="primary"
                    mat-flat-button data-tour="evt-save">
              GUARDAR
            </button>
            <button (click)="onNoClick()" color="warn" mat-flat-button tabindex="-1">CANCELAR</button>
          </div>
        </div>
      </div>

    </form>
  </div>
</div>
